import React from 'react';
import { ActivityIndicator } from '@lyearn-team/frontend-components';
import * as s from './styles';

class ContentLoader extends React.PureComponent {
  render() {
    const fullScreen = this.props.fullScreen;
    if (fullScreen) {
      return <ActivityIndicator.FullScreenV2 />;
    }
    return (
      <div className={s.root}>
        <ActivityIndicator />
      </div>
    );
  }
}

export default ContentLoader;
